<template>
  <div
    class="flex items-center h-8 w-8 md:w-10 md:h-10 rounded-full"
    :style="{ 'z-index': zIndex * 2 }"
  >
    <img
      v-if="photo && !imageError"
      :src="photo"
      class="inline object-cover w-8 h-8 md:w-10 md:h-10 rounded-full"
      @error="imageError = true"
      :style="{ 'z-index': zIndex * 2 }"
    />
    <div
      v-else
      class="
        h-full
        w-full
        relative
        flex
        object-cover
        rounded-full
        items-center
        justify-center
      "
      :class="[color]"
      :style="{ 'z-index': zIndex * 2 }"
    >
      <p class="text-white uppercase">{{ displayName }}</p>
    </div>
    <img
      v-if="displayCutout"
      class="w-8 h-8 md:w-10 md:h-10 absolute ml-0.5"
      :style="{ 'z-index': zIndex * 2 - 1 }"
      src="@/assets/images/gravatar-cutout.svg"
    />
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "bg-purple-600"
    },
    photo: {
      type: String
    },
    zIndex: {
      type: Number,
      default: 10
    },
    displayName: {
      type: String
    },
    displayCutout: {
      type: Boolean,
      default: true
    }
  },
  methods: {},
  data() {
    return {
      imageError: false
    }
  }
}
</script>
